import '../../../assets/js/jquery.qrcode.min.js';

const loadQrCode = (shouldLoadQrCode) => {
    if (shouldLoadQrCode) {
        const androidApk = document.getElementById('android-apk');
        const appleApk = document.getElementById('apple-apk');

        if (appleApk) {
            $("#apple-qr-code").qrcode({
                render: 'canvas',
                text: appleApk.href,
            });
        }

        if (androidApk) {
            $("#android-qr-code").qrcode({
                render: 'canvas',
                text: androidApk.href
            });
        }
    }

    else {
        const androidQrCode = document.getElementById('android-qr-code')
        const appleQrCode = document.getElementById('apple-qr-code')

        androidQrCode?.replaceChildren();
        appleQrCode?.replaceChildren();
    }

}

const mobileBreakpoint = window.matchMedia("(min-width: 991.98px)");
mobileBreakpoint.addEventListener('change', ({matches}) => loadQrCode(matches));
void loadQrCode(mobileBreakpoint.matches);
